import $ from 'jquery';
import { InventorySearchEvents } from '@dealersites/inventory/events';

import { LocalGarage } from './local';
import { syncGlobalGarageIcon } from './utils';

$(document).on(InventorySearchEvents.GARAGE_UPDATED, syncGlobalGarageIcon);

const $garageCover = $('#garage-cover');
if ($garageCover.length) {
  $(document).on(InventorySearchEvents.GARAGE_ITEM_ADD, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_ADDED, () => {
    $garageCover.addClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_REMOVE, (...args) => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_REMOVED, (event, data) => {
    const $itemGarageEl = $(`#garage-item-${data.id}`);

    setTimeout(() => {
      if ($itemGarageEl.length) {
        $itemGarageEl.remove();
      }

      $garageCover.addClass('hidden');
    }, 1000);
  });

  $(document).on(InventorySearchEvents.GARAGE_CLEAR, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_CLEARED, () => {
    const $garageItemEls = $(`.garage-vehicles [id^='garage-item-']`);

    setTimeout(() => {
      if ($garageItemEls.length) {
        $garageItemEls.remove();
      }

      $garageCover.addClass('hidden');
    }, 1000);
  });
}

$(document).on(InventorySearchEvents.POST_RENDER, () => {
  LocalGarage.init();
});

LocalGarage.init();
